import React, { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

interface DrawerContentProps {
  children: ReactNode;
  padding?: number;
  fullHeight?: boolean;
}

/**
 * Reusable wrapper component for drawer content with consistent styling
 */
const DrawerContent: FC<DrawerContentProps> = ({ children, padding = 2, fullHeight = true }) => {
  return (
    <Box
      width="100%"
      sx={{
        py: padding,
        display: 'flex',
        flexDirection: 'column',
        flex: fullHeight ? 1 : undefined,
        minHeight: fullHeight ? 0 : undefined,
        height: fullHeight ? '100%' : undefined,
      }}>
      {children}
    </Box>
  );
};

export default DrawerContent;

